/* eslint-disable react/require-default-props */
import React from 'react';
import { Box, Icon, SkeletonLoader, Typography } from '@saviynt/design-system';

import { type KpiData } from '../KpiTiles';

import './KpiTile.css';

interface KpiTileProps {
  data: KpiData | Partial<KpiData>; // Allow partial data during loading
  isLoading?: boolean;
}

function KpiTile({ data, isLoading = false }: KpiTileProps) {
  const { title, value, subtitle, /* change, */ icon } = data;

  return (
    <Box tag='article' className='Roles-KpiTile'>
      <Box tag='header' className='Roles-KpiTile-header'>
        <Typography kind='h4' className='Roles-KpiTile-title'>
          {title}
        </Typography>
        <Box className='Roles-KpiTile-iconWrapper'>
          <Icon
            kind={icon}
            color='--color-foreground-neutral-bold'
            className='Roles-KpiTile-icon'
          />
        </Box>
      </Box>
      <Box className='Roles-KpiTile-content'>
        {isLoading ? (
          <>
            {/* Skeleton for main value (taller) */}
            <SkeletonLoader
              animationStyle='wave'
              height='2rem'
              width='100%'
              className='Roles-KpiTile-valueSkeleton'
            />
            {/* Skeleton for subtitle (shorter) */}
            <SkeletonLoader
              animationStyle='wave'
              height='1.15rem'
              width='80%'
              className='Roles-KpiTile-subtitleSkeleton'
            />
          </>
        ) : (
          <>
            <Typography kind='h1' className='Roles-KpiTile-value'>
              {value}
            </Typography>
            <Typography
              kind='body2'
              color='--color-foreground-neutral-subtle'
              className='Roles-KpiTile-subtitle'>
              {subtitle}
            </Typography>
          </>
        )}
      </Box>
      {/*
      TODO: delta comes in a future mvp
      <Box className='Roles-KpiTile-deltaInfo'>
        <Typography
          kind='body3'
          className={`Roles-KpiTile-change Roles-KpiTile-change--${change.type}`}>
          {change.value}
        </Typography>
      </Box> */}
    </Box>
  );
}

export default KpiTile;
